import { VoiceInfo } from 'modules/sdk/lib';
import { getVoiceByIDQualified } from 'modules/voices/utils/utils';

import { useVoiceStore } from '../voicesStore';
import { MAX_HISTORY_SIZE } from './setVoice';

export const setVoiceHistory = (voices: string[], allVoices: VoiceInfo[]) => {
  useVoiceStore.setState(() => {
    const voiceHistory = voices.map(id => getVoiceByIDQualified(id, allVoices)).filter(v => v !== undefined) as VoiceInfo[];
    return {
      selectionHistory: voiceHistory.slice(0, MAX_HISTORY_SIZE)
    };
  });
};
